export const HOME = "/";
export const REG_01 = "reg-01";
export const REG_02 = "reg-02";
export const REG_PERSONAL_NUMBER = "reg-personal-number";
export const REG_LAST_NAME = "reg-last-name";
export const REG_NAME = "reg-name";
export const REG_INUSRANCE = "reg-insurance";
export const REG_SUMMARY = "reg-summary";
export const PAGE_ERROR = "error";
export const PAGE_ERROR_NOT_ENABLED = "error-not-enabled";
export const PAGE_ERROR_NOT_FOUND = "error-not-found";
export const PAGE_ERROR_PAGE_EXPIRED = "error-page-expired";
export const PAGE_ERROR_LOG = "error-log";
export const PAGE_TEST = "test";

export const PAGE_TERMINAL_ID = "terminal-id";
export const PAGE_API_ID = "api-url";

export const HOME_INDEX = 0;
export const REG_01_INDEX = 1;
export const REG_02_INDEX = 2;
export const REG_SUMMARY_INDEX = 3;

export const REG_RPI_01_INDEX = 1;
export const REG_RPI_INUSRANCE_COMPANY_INDEX = 2;
export const REG_RPI_PERSONAL_NUMBER_INDEX = 3;
export const REG_RPI_LAST_NAME_INDEX = 4;
export const REG_RPI_NAME_INDEX = 5;
export const REG_RPI_SUMMARY_INDEX = 6;

export const OPERATION_RESTART = "restart";
export const OPERATION_SHUTDOWN = "shutdown";

const pageTerminalArray = [
  {
    index: HOME_INDEX,
    route: HOME,
  },
  {
    index: REG_01_INDEX,
    route: REG_01,
  },
  {
    index: REG_RPI_INUSRANCE_COMPANY_INDEX,
    route: REG_INUSRANCE,
  },
  {
    index: REG_RPI_PERSONAL_NUMBER_INDEX,
    route: REG_PERSONAL_NUMBER,
  },
  {
    index: REG_RPI_LAST_NAME_INDEX,
    route: REG_LAST_NAME,
  },
  {
    index: REG_RPI_NAME_INDEX,
    route: REG_NAME,
  },
  {
    index: REG_RPI_SUMMARY_INDEX,
    route: REG_SUMMARY,
  },
];

const pageArray = [
  {
    index: HOME_INDEX,
    route: HOME,
  },
  {
    index: REG_01_INDEX,
    route: REG_01,
  },
  {
    index: REG_02_INDEX,
    route: REG_02,
  },
  {
    index: REG_SUMMARY_INDEX,
    route: REG_SUMMARY,
  },
];
export function getIndexForPage(route) {
  let index = -1;
  const data = isTerminal() ? pageTerminalArray : pageArray;
  if (data) {
    index = data.find((item) => item.route === route)?.index ?? -1;
  }
  return index;
}

export const HW_CONTEXT_TERMINAL = 0;
export const HW_CONTEXT_MOBILE = 1;

export const SPLASH_TIME = process.env.REACT_APP_SPLASH_INTERVAL; //2s-0s
export const PAGE_EXPIRED_TIME = process.env.REACT_APP_EXPIRED_INTERVAL * 60 * 1000; // minute * sec * ms
export const PAGE_REG_SUMMARY_TERMINAL_TIME = process.env.REACT_APP_REG_SUMMARY_TERMINAL_EXPIRED_INTERVAL * 1000; // sec * ms
export const LOG_DELETE_INTERVAL = 5 * 1000; // sec * ms

export const MODE_DEV = "DEV";
export const MODE_PROD = "PROD";
export const MODE_PREP = "PREP";

export const SS_REG_TYPE = "BB1DA18946F69";
export const SS_UID = "83723B14C3E5D";
export const SS_START_TIME = "CEA63AA23571B";
export const LS_FIRST_NAME = "A6F157FA17E7A";
export const LS_LAST_NAME = "ED7E4F627FD93";
export const LS_INSURANCE = "7A92816762A89";
export const LS_PERSONAL_NUMBER = "623BCF1445C9D";
export const LS_EMAIL = "B78EA726D3D2E";
export const LS_ANIMATION_DISABLED = "9B4A64D967DE6285";

export const REG_TYPE_MOBILE_APP_QR = 2;
export const REG_TYPE_MOBILE_APP_NFC = 3;
export const REG_TYPE_MOBILE_APP_RPI = 4;

export const TERMINAL_BURES = "h7pj62fglimtzaql"; //3 page
export const TERMINAL_BURESOVA = "usids11fztuss5gy"; //2 page
export const TERMINAL_JA = "fbs7lgrsrdewz3u0"; //1 page
export const TERMINAL_PARDUBICE = "f1xys6k17aps230b"; //3 page
export const TERMINAL_MINARIKOVA = "j7bcxww8la0qqb0q"; //1 page dlouhe nazvy fronty
export const TERMINAL_UID = TERMINAL_BURES;

export function isProduction() {
  return process.env.REACT_APP_MODE === MODE_PROD ? true : false;
}

export function isPreproduction() {
  return process.env.REACT_APP_MODE === MODE_PREP ? true : false;
}

export function isDebugMode() {
  return process.env.REACT_APP_MODE === MODE_DEV ? true : false;
}

export const ENV = process.env.REACT_APP_MODE;

export function isTerminal() {
  return process.env.REACT_APP_HW_CONTEXT == HW_CONTEXT_TERMINAL ? true : false;
}

const LOCAL_API_URL = "https://localhost:44341/api";
const PRODUCTION_API_URL = "https://qapi.vloztekarticku.cz/api";
//const PRODUCTION_API_URL = "https://testqapi.vloztekarticku.cz/api";
export const API_URL = process.env.REACT_APP_API_URL; //isProduction() ? PRODUCTION_API_URL : LOCAL_API_URL;
